import { render, staticRenderFns } from "./InventoryBatchArrivalInfoModal.vue?vue&type=template&id=93f5e7fe&"
import script from "./InventoryBatchArrivalInfoModal.vue?vue&type=script&lang=js&"
export * from "./InventoryBatchArrivalInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports